import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import moment from 'moment';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'material-react-toastify';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../components/_dashboard/user';
import Label from '../components/Label';
import NotifModal from '../components/_dashboard/user/NotifModal';
import Loader from '../components/_dashboard/user/Loader';
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.child.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({}));

export default function PaymentValide() {
  const userDetails = JSON.parse(localStorage.getItem('user'));

  const TABLE_HEAD = [
    { id: 'iddepaiement', label: 'iddepaiement' },
    { id: 'abonnement', label: 'abonnement' },
    { id: 'enfant', label: 'enfant' },
    { id: 'créépar', label: 'créépar' },
    { id: 'crèche', label: 'crèche' },
    { id: 'crééà', label: 'crééà' },
    { id: 'statut', label: 'statut' },
    !userDetails.is_creche && { id: 'action', label: 'action' },
    { id: '' }
  ];

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [payment, setPayment] = useState([]);
  const [checked, setChecked] = useState(null);
  const [checkedAll, setCheckedAll] = useState(false);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notif, setNotif] = useState('');
  const [titleNotif, setTitleNotif] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const getDate = (data) => {
    let datetime = new Date(data);
    datetime = moment(datetime).format('YYYY-MM-DD');
    return datetime;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = payment.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - payment.length) : 0;

  const filteredUsers = applySortFilter(payment, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  // GET all Payment
  const retrievePayment = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/validate-payment/`,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  };

  useEffect(async () => {
    setIsLoading(true);
    const allPayment = await retrievePayment();
    console.log('Payment***', allPayment);
    if (allPayment) {
      setPayment(allPayment.results);
      setIsLoading(false);
    }
  }, []);

  const toggleCheck = (inputName) => {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  };

  const selectAll = (value) => {
    setCheckedAll(value);
    setChecked((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState).forEach((inputName) => (newState[inputName] = value));
      return newState;
    });
  };

  const kk = async () => {
    const all = await retrievePayment();
    const all2 = all.results;
    const form = [];
    for (let i = 0; i < all2.length; i += 1) {
      form.push(all2[i].id);
    }
    const initialState = form.reduce((o, key) => ({ ...o, [key]: false }), {});
    setChecked(initialState);
  };

  useEffect(() => {
    kk();
    console.log('jjjjj=>', checked);
  }, []);

  useEffect(() => {
    if (checked != null) {
      console.log('uuuuu=>', checked);
      let allChecked = true;
      Object.keys(checked).forEach((inputName) => {
        if (checked[inputName] === false) {
          allChecked = false;
        }
      });
      if (allChecked) {
        setCheckedAll(true);
      } else {
        setCheckedAll(false);
      }
    }
  }, [checked]);

  useEffect(() => {
    if (checked != null) {
      let allChecked = false;
      Object.keys(checked).forEach((inputName) => {
        if (checked[inputName] === true) {
          allChecked = true;
        }
      });
      if (allChecked) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }
  }, [checked]);

  const notifySuccess = (message) => {
    toast.success(message, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  const Valide = (id, listId) => {
    console.log('listId==>', id);
    const formData = new FormData();
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    if (id != null) {
      formData.append('liste', id);
    }
    if (listId != null) {
      listId.forEach((item) => formData.append('liste', item));
    }
    axios({
      method: 'POST',
      url: `${API_ENDPOINT}/api/validate-payment/`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
      .then((res) => {
        console.log('response', res.data);
        selectAll(false);
        if (id != null) {
          setPayment(
            payment.map((c) => {
              if (c.id === id) {
                c.status = userDetails.is_admin && 'validation by admin';
              }
              return c;
            })
          );
        }
        if (listId != null) {
          console.log('listId=   =>', listId);
          console.log('pay=   =>', payment);
          setPayment(
            payment.map((item) => {
              if (listId.some((ID) => ID === `${item.id}`)) {
                item.status = userDetails.is_admin && 'validation by admin';
              }
              return item;
            })
          );
        }
        notifySuccess('vous avez valider ces paiements');
      })
      .catch((err) => {
        console.log('err', err.message);
      });
  };

  const Refuse = (id, listId) => {
    console.log('listId==>', id);
    const formData = new FormData();
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    if (id != null) {
      formData.append('liste', id);
    }
    if (listId != null) {
      listId.forEach((item) => formData.append('liste', item));
    }
    axios({
      method: 'POST',
      url: `${API_ENDPOINT}/api/refuse-payment/`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
      .then((res) => {
        console.log('response', res.data);
        selectAll(false);
        if (id != null) {
          const newList = payment.filter((c) => c.id !== id);
          setPayment(newList);
        }
        if (listId != null) {
          console.log('listId=   =>', listId);
          console.log('pay=   =>', payment);
          const newList = payment.filter((item) => !listId.includes(`${item.id}`));
          setPayment(newList);
        }
        notifySuccess('vous avez refusez ces paiements');
      })
      .catch((err) => {
        console.log('err', err.message);
      });
  };

  const Archive = (id, listId) => {
    console.log('listId==>', id);
    const formData = new FormData();
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    if (id != null) {
      formData.append('liste', id);
    }
    if (listId != null) {
      listId.forEach((item) => formData.append('liste', item));
    }
    axios({
      method: 'POST',
      url: `${API_ENDPOINT}/api/archive-payment/`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
      .then((res) => {
        console.log('response', res.data);
        selectAll(false);
        if (id != null) {
          const newList = payment.filter((c) => c.id !== id || c.status === 'validation by admin');
          setPayment(newList);
        }
        if (listId != null) {
          const newList = payment.filter(
            (item) => !listId.includes(`${item.id}`) || item.status === 'validation by admin'
          );
          console.log('lololo', newList);
          setPayment(newList);
        }
        notifySuccess('vous avez archiver ces paiements');
      })
      .catch((err) => {
        console.log('err', err.message);
      });
  };

  const sel = (func) => {
    console.log('func ==>', func);
    const FormatData = [];
    Object.keys(checked).forEach((inputName) => {
      if (checked[inputName] === true) {
        FormatData.push(inputName);
      }
    });
    if (func === 'valide') {
      Valide(null, FormatData);
    }
    if (func === 'archive') {
      Archive(null, FormatData);
    }
    if (func === 'refuse') {
      Refuse(null, FormatData);
    }
  };

  return (
    <Page title="Paiement">
      <ToastContainer />
      <Container>
        <Loader load={isLoading} />
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('validationparcommercial')}
          </Typography>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={visible}
            filterName={filterName}
            onFilterName={handleFilterByName}
            holder={`${t('search')}...`}
            click={sel}
            paymentPayment
            isValide={!userDetails.is_creche && !userDetails.is_commercial}
            isRefuse={!userDetails.is_creche}
            isArchive={!userDetails.is_creche}
            clickDelete={() => sel('archive')}
            clickRefused={() => sel('refuse')}
            clickValide={() => sel('valide')}
            btnName={t('Ajouternotification')}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={payment.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  checkFunc={(event) => selectAll(event.target.checked)}
                  check={checkedAll}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const isItemSelected = selected.indexOf(row.id) !== -1;
                      const API_ENDPOINT = process.env.REACT_APP_BASE_URL;

                      return (
                        <TableRow
                          hover
                          key={row.id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <StyledTableCell
                            component="th"
                            scope="row"
                            padding="none"
                            style={{
                              paddingLeft: document.body.dir === 'rtl' ? 0 : 20,
                              paddingRight: document.body.dir === 'rtl' ? 20 : 0
                            }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Checkbox
                                onChange={() => toggleCheck(row.id)}
                                checked={checked !== null && checked[row.id]}
                                sx={{
                                  color: '#f78181',
                                  '&.Mui-checked': {
                                    color: '#f78181'
                                  }
                                }}
                              />
                              <Typography variant="subtitle2" noWrap>
                                {row.id}
                              </Typography>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>{row.abonnement}</StyledTableCell>
                          <StyledTableCell>{row.child}</StyledTableCell>
                          <StyledTableCell>{row.creche_name}</StyledTableCell>
                          <StyledTableCell>{getDate(row.created_at)}</StyledTableCell>
                          <StyledTableCell>{row.status}</StyledTableCell>
                          <StyledTableCell style={{ display: 'flex' }}>
                            {!userDetails.is_creche && (
                              <>
                                {userDetails.is_admin && (
                                  <IconButton
                                    onClick={() => Valide(row.id, null)}
                                    size="small"
                                    aria-label="upload picture"
                                    component="span"
                                  >
                                    <CheckIcon color="#a7b0b8" />
                                  </IconButton>
                                )}
                                <IconButton
                                  onClick={() => Refuse(row.id, null)}
                                  size="small"
                                  aria-label="upload picture"
                                  component="span"
                                >
                                  <CloseIcon style={{ color: 'red' }} />
                                </IconButton>
                              </>
                            )}
                          </StyledTableCell>
                          <StyledTableCell>
                            {!userDetails.is_creche && (
                              <UserMoreMenu
                                handeldelete={() => {
                                  Archive(row.id, null);
                                }}
                              />
                            )}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25]}
            component="div"
            count={payment.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        <NotifModal
          open={isOpen}
          notif={notif}
          setNotif={setNotif}
          title={titleNotif}
          setTitle={setTitleNotif}
          listId={list}
          clickCancel={() => {
            setIsOpen(false);
            setNotif('');
            setTitleNotif('');
            selectAll(false);
          }}
        />
      </Container>
    </Page>
  );
}
